import React from 'react';
import TapeCaseProductDetailsContext from './TapeCaseProductDetailsContext';
import useTapeCaseProductDetails from './useTapeCaseProductDetails';

const { Provider } = TapeCaseProductDetailsContext;

const TapeCaseProductDetailsProvider = (props) => {
	const { actor, state } = useTapeCaseProductDetails();

	return <Provider value={{ state: { ...state }, actor: { ...actor } }}>{props.children}</Provider>;
};

export { TapeCaseProductDetailsProvider, TapeCaseProductDetailsContext };
